import { request } from "services/api/util";

class ContactService {
  async getListContacts(param) {
    const config = {
      method: "get",
      url: `admin/contactSubject`,
      params: param,
      headers: {
        "content-type": "	application/json;charset=UTF-8",
      },
    };
    return request(config);
  }

  async getDetailContactSubject(contactSubjectId) {
    const config = {
      method: "get",
      url: `admin/contactSubject/${contactSubjectId}`,
      headers: {
        "content-type": "application/json;charset=UTF-8",
      },
    };

    return request(config);
  }

  async createOrUpdateContactSubject(body, contactSubjectId, update) {
    let config;
    if (update) {
      config = {
        method: "put",
        url: `admin/contactSubject/${contactSubjectId}`,
        data: body,
        headers: {
          "Accept-Language": "th",
          "content-type": "	application/json;charset=UTF-8",
        },
      };
    } else {
      config = {
        method: "post",
        url: `admin/contactSubject`,
        data: body,
        headers: {
          "Accept-Language": "th",
          "content-type": "	application/json;charset=UTF-8",
        },
      };
    }

    return request(config);
  }
}

export default new ContactService();
